export const batyaQuest = {
    id: 'batya',
    titleKey: 'chapter_batya',
    shortName: 'BATYA',
    date: '15.01.2026',
    status: 'completed',
    questMap: [
        {
            id: 'step_start_quest',
            label: {
                en: "Getting a quest",
                tr: "Görev alma",
                ru: "Получение квеста"
            },
            type: 'start',
            isSubTask: false,
            details: {
                location: { en: "Customs / Reserve / Shoreline / Woods", tr: "Gümrük / Rezerv / Kıyı Şeridi / Ormanlık", ru: "Таможня / Резерв / Берег / Лес" },
                objective: {
                    en: "Obtain the Batya chapter by visiting one of the four trigger locations.",
                    tr: "Dört tetikleyici konumdan birini ziyaret ederek Batya bölümünü başlat.",
                    ru: "Получите главу «Батя», посетив одну из четырёх точек запуска."
                },
                story: {
                    en: "Turns out BEAR didn't send just regular squads into Tarkov, there were real SOF guys here. I'd like to know more about those units and what exactly they were doing.",
                    tr: "BEAR'in Tarkov'a sadece sıradan mangalar göndermediği, burada gerçek özel kuvvetler askerlerinin de olduğu ortaya çıktı. Bu birimler ve tam olarak ne yaptıkları hakkında daha fazla bilgi edinmek istiyorum.",
                    ru: "Оказывается, BEAR отправлял в Тарков не просто обычные отряды, здесь были настоящие спецназовцы. Хочу узнать больше об этих подразделениях и чем именно они занимались."
                },
                guideSteps: [
                    {
                        text: {
                            en: "First method: Go to the supply crate at Reshala's base on Customs (the 'Stronghold') on the second floor.",
                            tr: "Birinci yöntem: Gümrük haritasında Reşala'nın üssündeki 'Stronghold/Kale'nin ikinci katında bulunan tedarik sandığına git.",
                            ru: "Первый способ: Подойдите к ящику с припасами на базе Решалы на Таможне («саркофаг») на втором этаже."
                        },
                        images: ['/Story/Batya/Step1/Customs1-1.webp', '/Story/Batya/Step1/Customs1-1 (2).webp']
                    },
                    {
                        text: {
                            en: "Second method: Enter the 'RLS' radar tower building on Reserve (also known as the Chupa-Chups). Enter the white sphere at the top.",
                            tr: "İkinci yöntem: Rezerv haritasındaki 'RLS' radar kulesi binasına (Chupa-Chups olarak da bilinir) gir. Üstteki beyaz küreye ulaş.",
                            ru: "Второй способ: Зайдите в здание радарной башни «РЛС» на Резерве (также известную как Чупа-Чупс). Войдите в белую сферу наверху."
                        },
                        images: ['/Story/Batya/Start-Reserve.webp']
                    },
                    {
                        text: {
                            en: "Third method: Climb onto the rock near the USEC camp in Woods — the one where a weapon can spawn, next to the small camp.",
                            tr: "Üçüncü yöntem: Ormanlık haritasında USEC kampının yanındaki kayaya tırman — küçük kampın yanındaki, üzerinde silah belirebilen kaya.",
                            ru: "Третий способ: Залезьте на скалу рядом с лагерем USEC в Лесу — ту, где может появиться оружие, рядом с маленьким лагерем."
                        },
                        images: ['/Story/Batya/Start-Woods.webp']
                    },
                    {
                        text: {
                            en: "Fourth method: Approach the bunker behind the Health Resort on Shoreline (where one of the quest tanks is located). The quest will be given at the bunker entrance.",
                            tr: "Dördüncü yöntem: Kıyı Şeridi haritasında Sağlık Merkezi'nin arkasındaki sığınağa yaklaş (görev tanklarından birinin olduğu yer). Görev sığınağın girişinde verilecek.",
                            ru: "Четвертый способ: Подойдите к бункеру за Санаторием на Берегу (где находится один из квестовых танков). Квест выдается у входа в бункер."
                        },
                        images: ['/Story/Batya/Start-Shoreline.webp']
                    }
                ]
            }
        },
        {
            id: 'step_find_bear_traces',
            label: {
                en: "Find traces of the BEAR special forces unit",
                tr: "BEAR özel kuvvetler birliğinin izlerini bul",
                ru: "Найти следы спецподразделения BEAR"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Customs / Woods / Reserve / Shoreline", tr: "Gümrük / Ormanlık / Rezerv / Kıyı Şeridi", ru: "Таможня / Лес / Резерв / Берег" },
                objective: {
                    en: "Locate and obtain the Bogatyr squad patch from one of the BEAR camps.",
                    tr: "BEAR kamplarının birinden Bogatyr takım yamasını bul ve al.",
                    ru: "Найдите и заберите нашивку отряда «Богатыри» в одном из лагерей BEAR."
                },
                story: {
                    en: "I should check BEAR outposts. The patch might tell me more about this special squad.",
                    tr: "BEAR karakollarını kontrol etmeliyim. Bu yama, özel takım hakkında bana daha fazla bilgi verebilir.",
                    ru: "Нужно проверить лагеря BEAR. Нашивка может рассказать больше об этом спецотряде."
                },
                requiredItems: [
                    { en: "Bogatyrs patch", tr: "Bogatyr Yaması", ru: "Нашивка Богатырей" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Customs: On a couch inside the cabin located on top of the hill southwest of the new gas station.",
                            tr: "Gümrük: Yeni benzin istasyonunun güneybatısındaki tepenin üzerinde bulunan kulübenin içindeki kanepenin üzerinde.",
                            ru: "Таможня: На диване внутри домика на вершине холма к юго-западу от новой заправки."
                        },
                        images: ['/Story/Batya/Patch-CustomsMap.webp', '/Story/Batya/Patch-CustomsCabin.webp']
                    },
                    {
                        text: {
                            en: "Woods: On the ground next to the BRDM from the cargo convoy.",
                            tr: "Ormanlık: Kargo konvoyundaki BRDM'nin hemen yanında, yerde.",
                            ru: "Лес: На земле рядом с БРДМ из грузового конвоя."
                        },
                        images: ['/Story/Batya/Patch-WoodsMap.webp', '/Story/Batya/Patch-WoodsBRDM.webp']
                    },
                    {
                        text: {
                            en: "Reserve: On a package on the upper roof of the airspace control center marked with white king.",
                            tr: "Rezerv: Beyaz kral işaretli hava sahası kontrol merkezinin üst çatısındaki bir paketin üzerinde.",
                            ru: "Резерв: На посылке на верхней крыше центра контроля воздушного пространства, помеченного белым королем."
                        },
                        images: ['/Story/Batya/Patch-ReserveMap.webp', '/Story/Batya/Patch-ReserveRoof.webp']
                    },
                    {
                        text: {
                            en: "Lighthouse: On a tree stump in the BEAR camp.",
                            tr: "Deniz Feneri: BEAR kampındaki bir ağaç kütüğünün üzerinde.",
                            ru: "Маяк: На пне в лагере BEAR."
                        },
                        images: ['/Story/Batya/Patch-LighthouseMap.webp', '/Story/Batya/Patch-LighthouseCamp.webp']
                    }
                ]
            }
        },
        {
            id: 'step_talk_jaeger',
            label: {
                en: "Conversation with Jaeger",
                tr: "Jaeger ile konuşma",
                ru: "Разговор с Егерем"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Visit Jaeger and ask him about the BEAR patch.",
                    tr: "Jaeger'i ziyaret et ve ona BEAR yaması hakkında sorular sor.",
                    ru: "Посетите Егеря и спросите его о нашивке BEAR."
                },
                story: {
                    en: "Jaeger told me a bit about the Bogatyrs and marked two of their former camp locations. They used to operate from two BEAR outposts: 'Gnezdo' and 'Ryabina'.",
                    tr: "Jaeger bana Bogatyr'lar hakkında biraz bilgi verdi ve eski kamp konumlarından ikisini işaretledi. Eskiden iki BEAR karakolundan operasyon yaparlarmış: 'Gnezdo' ve 'Ryabina'.",
                    ru: "Егерь рассказал мне немного о Богатырях и отметил два их бывших лагеря. Они действовали из двух аванпостов BEAR: «Гнездо» и «Рябина»."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open Traders menu. Select Jaeger. Complete the dialogue about the Bogatyr squad.",
                            tr: "Satıcılar menüsünü aç. Jaeger'i seç. Bogatyr takımı hakkındaki diyalogu tamamla.",
                            ru: "Откройте меню торговцев. Выберите Егеря. Завершите диалог об отряде Богатырей."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_find_ryabina',
            label: {
                en: "Find the Ryabina position",
                tr: "Ryabina mevziini bul",
                ru: "Найти позицию «Рябина»"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Woods", tr: "Ormanlık", ru: "Лес" },
                objective: {
                    en: "Locate the Ryabina outpost and collect the intel.",
                    tr: "Ryabina karakolunu bul ve istihbaratı topla.",
                    ru: "Найдите аванпост «Рябина» и соберите разведданные."
                },
                story: {
                    en: "It should be somewhere on the ridge in the Priozersk forest, it was used as an observation point.",
                    tr: "Priozersk ormanındaki sırtın üzerinde bir yerlerde olmalı, orayı gözlem noktası olarak kullanıyorlardı.",
                    ru: "Должно быть где-то на хребте в Приозерском лесу, использовалось как наблюдательный пункт."
                },
                requiredItems: [
                    { en: "Hostage evacuation report from Voevoda", tr: "Voevoda'dan rehine tahliye raporu", ru: "Доклад об эвакуации заложников от Воеводы" },
                    { en: "Strelets' amulet", tr: "Strelets'in tılsımı", ru: "Амулет Стрельца" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Woods. Navigate north of the sawmill to the rocky hills.",
                            tr: "Ormanlık haritasına git. Testere fabrikasının kuzeyindeki kayalık tepelere doğru ilerle.",
                            ru: "Отправляйтесь в Лес. Двигайтесь на север от лесопилки к скалистым холмам."
                        },
                        images: ['/Story/Batya/Ryabina-Map.webp']
                    },
                    {
                        text: {
                            en: "Find the broken gate with a wrecked SUV. Head up the rocky hill to the left.",
                            tr: "Hasarlı SUV'un yanındaki kırık kapıyı bul. Soldaki kayalık tepeye tırman.",
                            ru: "Найдите сломанные ворота с разбитым внедорожником. Поднимитесь на скалистый холм слева."
                        },
                        images: ['/Story/Batya/Ryabina-Outpost.webp']
                    },
                    {
                        text: {
                            en: "Item 1: 'Hostage Evacuation Report from Voevoda' on wooden pallets leaning against a tree.",
                            tr: "1. Eşya: Ağaca yaslanmış ahşap paletlerin üzerinde 'Voevoda'dan Rehine Tahliye Raporu'.",
                            ru: "Предмет 1: «Доклад об эвакуации заложников от Воеводы» на деревянных поддонах, прислоненных к дереву."
                        },
                        images: ['/Story/Batya/Ryabina-Report.webp']
                    },
                    {
                        text: {
                            en: "Item 2: 'Strelets' Amulet' at the sandbag sniper nest down the hill overlooking the road.",
                            tr: "2. Eşya: Yola bakan tepenin aşağısındaki kum torbası keskin nişancı yuvasında 'Strelets'in Tılsımı'.",
                            ru: "Предмет 2: «Амулет Стрельца» в снайперском гнезде из мешков с песком вниз по склону с видом на дорогу."
                        },
                        images: ['/Story/Batya/Ryabina-Amulet.webp']
                    }
                ]
            }
        },
        {
            id: 'step_find_gnezdo',
            label: {
                en: "Find the Nest outpost",
                tr: "Yuva (Gnezdo) karakolunu bul",
                ru: "Найти аванпост «Гнездо»"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Interchange", tr: "Değişim", ru: "Развязка" },
                objective: {
                    en: "Locate the Gnezdo outpost east of the ULTRA shopping mall and collect all intel.",
                    tr: "ULTRA alışveriş merkezinin doğusundaki Gnezdo karakolunu bul ve tüm istihbaratı topla.",
                    ru: "Найдите аванпост «Гнездо» к востоку от ТЦ Ультра и соберите всю развединформацию."
                },
                story: {
                    en: "I need to figure out what happened to the Bogatyr squad and learn more about their members and activities.",
                    tr: "Bogatyr takımına ne olduğunu anlamam, üyeleri ve faaliyetleri hakkında daha fazla bilgi edinmem gerekiyor.",
                    ru: "Нужно выяснить, что случилось с отрядом Богатырей, и узнать больше об их членах и деятельности."
                },
                warning: {
                    en: "There are a LOT of items here. Make sure to read/examine everything so the game registers completion.",
                    tr: "Burada ÇOK FAZLA eşya var. Oyunun görevi tamamlanmış sayması için her şeyi okuduğundan veya incelediğinden emin ol.",
                    ru: "Здесь ОЧЕНЬ МНОГО предметов. Обязательно прочитайте/осмотрите всё, чтобы игра засчитала выполнение."
                },
                requiredItems: [
                    { en: "Moreman's personal file", tr: "Moreman'in kişisel dosyası", ru: "Личное дело Морремана" },
                    { en: "Bogatyr squad operations report", tr: "Bogatyr takımının operasyon raporu", ru: "Доклад об операциях отряда Богатырей" },
                    { en: "Map with triangulated signal", tr: "Üçgenleme sinyali içeren harita", ru: "Карта с триангулированным сигналом" },
                    { en: "BEAR note from the outpost behind Ultra", tr: "Ultra'nın arkasındaki karakoldan BEAR notu", ru: "Записка BEAR с аванпоста за Ультрой" },
                    { en: "First piece of code note", tr: "İlk kod parçası notu", ru: "Записка с первой частью кода" },
                    { en: "Audio tape with report", tr: "Rapor içeren ses kaseti", ru: "Аудиокассета с докладом" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Interchange. Head east of the shopping center into the wooded area.",
                            tr: "Değişim haritasına git. Alışveriş merkezinin doğusundaki ormanlık alana doğru ilerle.",
                            ru: "Отправляйтесь на Развязку. Двигайтесь к востоку от торгового центра в лесистую зону."
                        },
                        images: ['/Story/Batya/Gnezdo-Map.webp']
                    },
                    {
                        text: {
                            en: "BEAR Note: On the blue chair outside the tent next to the fire barrel.",
                            tr: "BEAR Notu: Çadırın dışındaki ateş varilinin yanında duran mavi sandalyenin üzerinde.",
                            ru: "Записка BEAR: На синем стуле снаружи палатки рядом с бочкой с огнем."
                        },
                        images: ['/Story/Batya/Gnezdo-BearNote.webp']
                    },
                    {
                        text: {
                            en: "Under the net tarp: 'Map with Triangulated Signal' in the green sleeping bag. 'Bogatyr Squad Operations Report' on the green box with the guitar.",
                            tr: "Kamuflaj ağının altında: Yeşil uyku tulumunun içinde 'Üçgenleme Sinyali İçeren Harita'. Gitarın olduğu yeşil kutunun üzerinde 'Bogatyr Takımının Operasyon Raporu'.",
                            ru: "Под маскировочной сетью: «Карта с триангулированным сигналом» в зеленом спальном мешке. «Доклад об операциях отряда Богатырей» на зеленом ящике с гитарой."
                        },
                        images: ['/Story/Batya/Gnezdo-SleepingBag.webp', '/Story/Batya/Gnezdo-Guitar.webp']
                    },
                    {
                        text: {
                            en: "'First Piece of Code Note' on the pallet with the green cloth. 'Moreman's Personal File' on a bed in the tent. 'Audio Tape with Report' on the table with the radio system.",
                            tr: "Yeşil örtülü paletin üzerinde 'İlk Kod Parçası Notu'. Çadırdaki yatağın üzerinde 'Moreman'in Kişisel Dosyası'. Radyo sisteminin olduğu masada 'Rapor İçeren Ses Kaseti'.",
                            ru: "«Записка с первой частью кода» на поддоне с зеленой тканью. «Личное дело Морремана» на койке в палатке. «Аудиокассета с докладом» на столе с радиосистемой."
                        },
                        images: ['/Story/Batya/Gnezdo-Code.webp', '/Story/Batya/Gnezdo-File.webp', '/Story/Batya/Gnezdo-Tape.webp']
                    }
                ]
            }
        },
        {
            id: 'step_find_carousel',
            label: {
                en: "Find the Carousel outpost",
                tr: "Carousel karakolunu bul",
                ru: "Найти аванпост «Карусель»"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Interchange", tr: "Değişim", ru: "Развязка" },
                objective: {
                    en: "Locate the Carousel outpost inside IDEA and collect all squad items.",
                    tr: "IDEA mağazasının içindeki Carousel karakolunu bul ve tüm takım eşyalarını topla.",
                    ru: "Найдите аванпост «Карусель» внутри ИДЕИ и соберите все предметы отряда."
                },
                story: {
                    en: "I need to learn more about Strelets, Taran, and Voevoda. Their personal files and notes should be at the Carousel outpost.",
                    tr: "Strelets, Taran ve Voevoda hakkında daha fazla şey öğrenmem gerekiyor. Kişisel dosyaları ve notları Carousel karakolunda olmalı.",
                    ru: "Нужно узнать больше о Стрельце, Таране и Воеводе. Их личные дела и записки должны быть на аванпосте «Карусель»."
                },
                warning: {
                    en: "Taran's postcard and Voevoda's audio recorder must be transferred to off-raid quest inventory to not lose them.",
                    tr: "Taran'ın kartpostalı ve Voevoda'nın ses kayıt cihazı, kaybetmemek için baskın dışı görev envanterine aktarılmalıdır.",
                    ru: "Открытку Тарана и аудиорегистратор Воеводы необходимо перенести в квестовый инвентарь вне рейда, чтобы не потерять."
                },
                requiredItems: [
                    { en: "Taran's personal file", tr: "Taran'ın kişisel dosyası", ru: "Личное дело Тарана" },
                    { en: "Voevoda's personal file", tr: "Voevoda'nın kişisel dosyası", ru: "Личное дело Воеводы" },
                    { en: "Strelets' personal file", tr: "Strelets'in kişisel dosyası", ru: "Личное дело Стрельца" },
                    { en: "Strelets' note", tr: "Strelets'in notu", ru: "Записка Стрельца" },
                    { en: "Taran's postcard", tr: "Taran'ın kartpostalı", ru: "Открытка Тарана" },
                    { en: "Voevoda's audio recorder (quest item)", tr: "Voevoda'nın ses kayıt cihazı (görev eşyası)", ru: "Аудиорегистратор Воеводы (квестовый предмет)" },
                    { en: "Voevoda's thoughts audio tape", tr: "Voevoda'nın düşüncelerini içeren ses kaseti", ru: "Аудиокассета с мыслями Воеводы" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Interchange IDEA store northwest corner. The outpost is near the checkout area.",
                            tr: "Değişim haritasındaki IDEA mağazasının kuzeybatı köşesine git. Karakol, kasa alanının yakınında.",
                            ru: "Отправляйтесь в северо-западный угол магазина ИДЕЯ на Развязке. Аванпост находится рядом с кассовой зоной."
                        },
                        images: ['/Story/Batya/Carousel-Map.webp']
                    },
                    {
                        text: {
                            en: "Ground floor: 'Voevoda's Audio Recorder' and 'Voevoda's Thoughts Audio Tape' on the desk with the radio system. 'Taran's Personal File' between the beds. 'Taran's Postcard' next to the left bed.",
                            tr: "Zemin kat: Radyo sisteminin olduğu masada 'Voevoda'nın Ses Kayıt Cihazı' ve 'Voevoda'nın Düşüncelerini İçeren Ses Kaseti'. Yatakların arasında 'Taran'ın Kişisel Dosyası'. Sol yatağın yanında 'Taran'ın Kartpostalı'.",
                            ru: "Первый этаж: «Аудиорегистратор Воеводы» и «Аудиокассета с мыслями Воеводы» на столе с радиосистемой. «Личное дело Тарана» между кроватями. «Открытка Тарана» рядом с левой кроватью."
                        },
                        images: ['/Story/Batya/Carousel-Table.webp', '/Story/Batya/Carousel-Beds.webp']
                    },
                    {
                        text: {
                            en: "Second floor: 'Voevoda's Personal File' on a desk with a chem light. 'Strelets' Personal File' on an armchair. 'Strelets' Note' on the wooden pallet next to bottles.",
                            tr: "İkinci kat: Kimyasal ışığın (chem light) bulunduğu masada 'Voevoda'nın Kişisel Dosyası'. Koltuğun üzerinde 'Strelets'in Kişisel Dosyası'. Şişelerin yanındaki ahşap paletin üzerinde 'Strelets'in Notu'.",
                            ru: "Второй этаж: «Личное дело Воеводы» на столе с химсветом. «Личное дело Стрельца» на кресле. «Записка Стрельца» на деревянном поддоне рядом с бутылками."
                        },
                        images: ['/Story/Batya/Carousel-SecondFloor.webp']
                    }
                ]
            }
        },
        {
            id: 'step_find_ambush',
            label: {
                en: "Find the ambush site",
                tr: "Pusu noktasını bul",
                ru: "Найти место засады"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Woods", tr: "Ormanlık", ru: "Лес" },
                objective: {
                    en: "Locate the ambush spot near ZB-016 extract and inspect Moreman's grave.",
                    tr: "ZB-016 çıkışının yanındaki pusu noktasını bul ve Moreman'in mezarını incele.",
                    ru: "Найдите место засады у выхода ZB-016 и осмотрите могилу Морремана."
                },
                story: {
                    en: "I need to figure out where the Bogatyr squad got ambushed. Moreman's grave should hold the answers.",
                    tr: "Bogatyr takımının nerede pusuya düşürüldüğünü bulmam gerekiyor. Moreman'in mezarı aradığım cevapları saklıyor olmalı.",
                    ru: "Нужно выяснить, где отряд Богатырей попал в засаду. Могила Морремана должна содержать ответы."
                },
                requiredItems: [
                    { en: "Moreman's phone", tr: "Moreman'in telefonu", ru: "Телефон Морремана" },
                    { en: "Moreman's dogtag", tr: "Moreman'in künyesi (dogtag)", ru: "Жетоны Морремана" },
                    { en: "Second piece of code note", tr: "İkinci kod parçası notu", ru: "Записка со второй частью кода" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Woods near ZB-016 extraction. The grave is east of the crashed plane and Old Sawmill.",
                            tr: "Ormanlık haritasında ZB-016 çıkışının yakınına git. Mezar, düşen uçağın ve Eski Testere Fabrikasının doğusunda yer alıyor.",
                            ru: "Отправляйтесь в Лес к выходу ZB-016. Могила находится к востоку от разбившегося самолета и старой лесопилки."
                        },
                        images: ['/Story/Batya/Ambush-Map.webp']
                    },
                    {
                        text: {
                            en: "'Moreman's Dogtag' on the rolled-up sleeping bag by the cross. 'Moreman's Phone' on the rocky grave. 'Second Piece of Code Note' in the boots by the grave.",
                            tr: "Haçın yanındaki rulo halindeki uyku tulumunun üzerinde 'Moreman'in Künyesi'. Kayalık mezarın üzerinde 'Moreman'in Telefonu'. Mezarın yanındaki çizmelerin içinde 'İkinci Kod Parçası Notu'.",
                            ru: "«Жетон Морремана» на свернутом спальном мешке у креста. «Телефон Морремана» на каменистой могиле. «Записка со второй частью кода» в ботинках у могилы."
                        },
                        images: ['/Story/Batya/Ambush-Grave.webp', '/Story/Batya/Ambush-Phone.webp']
                    }
                ]
            }
        },
        {
            id: 'step_study_phone',
            label: {
                en: "Study all the data from Moreman's phone",
                tr: "Moreman'in telefonundaki tüm verileri incele",
                ru: "Изучить все данные с телефона Морремана"
            },
            type: 'craft',
            isSubTask: false,
            details: {
                location: { en: "Hideout", tr: "Sığınak", ru: "Убежище" },
                objective: {
                    en: "Craft Moreman's audio tapes at Workbench level 1 and listen to them.",
                    tr: "Sığınaktaki Çalışma Tezgahı'nda (Seviye 1) Moreman'in ses kasetlerini üret ve dinle.",
                    ru: "Создайте аудиокассеты Морремана на Верстаке 1 уровня и прослушайте их."
                },
                warning: {
                    en: "Electricity is required during the entire craft process, otherwise it will be interrupted. Each craft takes ~12 hours.",
                    tr: "Üretim süreci boyunca kesintisiz elektrik gereklidir, aksi halde işlem iptal olur. Her bir kasetin üretimi yaklaşık 12 saat sürer.",
                    ru: "Электричество требуется на протяжении всего процесса крафта, иначе он прервется. Каждый крафт занимает ~12 часов."
                },
                requiredItems: [
                    { en: "Moreman's audio tape 1 (crafted)", tr: "Moreman'in ses kaseti 1 (üretilmiş)", ru: "Аудиокассета Морремана 1 (созданная)" },
                    { en: "Moreman's audio tape 2 (crafted)", tr: "Moreman'in ses kaseti 2 (üretilmiş)", ru: "Аудиокассета Морремана 2 (созданная)" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Hideout Workbench level 1. Craft 'Moreman's Audio Tape #1' and 'Moreman's Audio Tape #2'.",
                            tr: "Sığınaktaki Çalışma Tezgahı seviye 1'e git. 'Moreman'in Ses Kaseti #1' ve 'Moreman'in Ses Kaseti #2'yi üret.",
                            ru: "Зайдите в Убежище, Верстак 1 уровня. Создайте «Аудиокассету Морремана #1» и «Аудиокассету Морремана #2»."
                        }
                    },
                    {
                        text: {
                            en: "Listen to both tapes. You can play them from the Handbook or press M in raid for the last picked up tape.",
                            tr: "Her iki kaseti de dinle. Bunları El Kitabından (Handbook) dinleyebilir veya baskın sırasında son aldığın kaseti oynatmak için 'M' tuşuna basabilirsin.",
                            ru: "Прослушайте обе кассеты. Вы можете воспроизвести их из Справочника или нажать M в рейде для последней подобранной кассеты."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_intel_center',
            label: {
                en: "Build a level 3 Intelligence Center",
                tr: "3. seviye İstihbarat Merkezi inşa et",
                ru: "Построить Разведцентр 3 уровня"
            },
            type: 'upgrade',
            isSubTask: false,
            details: {
                location: { en: "Hideout", tr: "Sığınak", ru: "Убежище" },
                objective: {
                    en: "Upgrade the Intelligence Center to level 3 in the Hideout.",
                    tr: "Sığınaktaki İstihbarat Merkezi'ni 3. seviyeye yükselt.",
                    ru: "Улучшите Разведцентр до 3 уровня в Убежище."
                },
                story: {
                    en: "I need the Intelligence Center level 3 to contact the Bogatyr squad via the radio system.",
                    tr: "Bogatyr takımıyla radyo sistemi üzerinden iletişim kurabilmek için 3. seviye İstihbarat Merkezi'ne ihtiyacım var.",
                    ru: "Мне нужен Разведцентр 3 уровня, чтобы связаться с отрядом Богатырей по радио."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Upgrade Intelligence Center to level 3. This requires significant resources and other hideout modules at certain levels.",
                            tr: "İstihbarat Merkezi'ni 3. seviyeye yükselt. Bu işlem, önemli miktarda kaynak ve diğer sığınak modüllerinin belirli seviyelerde olmasını gerektirir.",
                            ru: "Улучшите Разведцентр до 3 уровня. Это требует значительных ресурсов и других модулей убежища на определенных уровнях."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_contact_lightkeeper',
            label: {
                en: "Talking to the Lightkeeper",
                tr: "Işık Muhafızı ile konuşma",
                ru: "Разговор со Смотрителем"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Gain access to Lightkeeper and bring all Bogatyr squad items to him.",
                    tr: "Işık Muhafızı'na (Lightkeeper) erişim sağla ve tüm Bogatyr takımı eşyalarını ona götür.",
                    ru: "Получите доступ к Смотрителю и принесите ему все предметы отряда Богатырей."
                },
                story: {
                    en: "I need to stay on good terms with Lightkeeper. He holds the key to contacting the Bogatyrs.",
                    tr: "Işık Muhafızı ile aramı iyi tutmalıyım. Bogatyr'larla iletişim kurmanın anahtarı onda.",
                    ru: "Нужно поддерживать хорошие отношения со Смотрителем. Он держит ключ к связи с Богатырями."
                },
                warning: {
                    en: "If you don't have Lightkeeper unlocked, complete the 'Network Provider' quest chain from Mechanic first.",
                    tr: "Eğer Işık Muhafızı'nın kilidini açmadıysan, önce Mekanik'ten aldığın 'Ağ Sağlayıcı' (Network Provider) görev serisini tamamlamalısın.",
                    ru: "Если у вас нет доступа к Смотрителю, сначала выполните цепочку квестов «Сетевой провайдер» от Механика."
                },
                requiredItems: [
                    { en: "Taran's postcard", tr: "Taran'ın kartpostalı", ru: "Открытка Тарана" },
                    { en: "Voevoda's audio recorder", tr: "Voevoda'nın ses kayıt cihazı", ru: "Аудиорегистратор Воеводы" },
                    { en: "Strelets' amulet", tr: "Strelets'in tılsımı", ru: "Амулет Стрельца" },
                    { en: "Moreman's dogtag", tr: "Moreman'in künyesi", ru: "Жетон Морремана" },
                    { en: "Bogatyrs patch", tr: "Bogatyr yaması", ru: "Нашивка Богатырей" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Lighthouse. Cross the bridge (requires encoded Digital secure DSP radio transmitter from Network Provider questline).",
                            tr: "Deniz Feneri haritasına git. Köprüyü geç (Bunun için Network Provider görev serisinden kodlanmış DSP radyo vericisi gerekir).",
                            ru: "Отправляйтесь на Маяк. Перейдите мост (требуется закодированный цифровой защищенный радиопередатчик DSP из цепочки квестов «Сетевой провайдер»)."
                        },
                        images: ['/Story/Batya/Lightkeeper-Bridge.webp']
                    },
                    {
                        text: {
                            en: "Enter the locked area on the 3rd floor of the lighthouse building. Hand over all 5 Bogatyr items to Lightkeeper.",
                            tr: "Deniz Feneri binasının 3. katındaki kilitli alana gir. Topladığın 5 Bogatyr eşyasını Işık Muhafızı'na teslim et.",
                            ru: "Войдите в запертую зону на 3 этаже здания маяка. Передайте все 5 предметов Богатырей Смотрителю."
                        },
                        images: ['/Story/Batya/Lightkeeper-Handover.webp']
                    }
                ]
            }
        },
        {
            id: 'step_wait_voevoda',
            label: {
                en: "Wait for the Voevoda to get in touch",
                tr: "Voevoda'nın iletişime geçmesini bekle",
                ru: "Дождаться связи от Воеводы"
            },
            type: 'wait',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Wait 12-24 hours, then contact Voevoda through the Intelligence Center radio.",
                    tr: "12-24 saat bekle, ardından İstihbarat Merkezi radyosu üzerinden Voevoda ile iletişime geç.",
                    ru: "Подождите 12-24 часа, затем свяжитесь с Воеводой через радио Разведцентра."
                },
                story: {
                    en: "Voevoda will reach out after some time. I need to be ready to contact him via the radio system.",
                    tr: "Voevoda bir süre sonra bana ulaşacak. Radyo sistemi üzerinden onunla iletişime geçmeye hazır olmalıyım.",
                    ru: "Воевода выйдет на связь через некоторое время. Нужно быть готовым связаться с ним по радиосистеме."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Wait 12-24 hours (real time). Then go to Intelligence Center radio.",
                            tr: "Gerçek zamanlı olarak 12-24 saat bekle. Daha sonra İstihbarat Merkezi radyosuna git.",
                            ru: "Подождите 12-24 часа (реального времени). Затем зайдите к радио Разведцентра."
                        }
                    },
                    {
                        text: {
                            en: "Enter frequency '35.70' and code '27.893.2000' (from Strelets' note and code pieces).",
                            tr: "Frekans olarak '35.70' ve kod olarak '27.893.2000' gir (Strelets'in notu ve birleştirdiğin kod parçalarından).",
                            ru: "Введите частоту «35.70» и код «27.893.2000» (из записки Стрельца и частей кода)."
                        },
                        images: ['/Story/Batya/Radio-Frequency.webp', '/Story/Batya/Radio-Code.webp']
                    }
                ]
            }
        },
        {
            id: 'step_complete_voevoda_tasks',
            label: {
                en: "Complete Voevoda's tasks",
                tr: "Voevoda'nın görevlerini tamamla",
                ru: "Выполнить задания Воеводы"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Various", tr: "Çeşitli", ru: "Различное" },
                objective: {
                    en: "Reach required skill levels and eliminate targets to prove yourself to Voevoda.",
                    tr: "Voevoda'ya kendini kanıtlamak için gereken yetenek seviyelerine ulaş ve hedefleri ortadan kaldır.",
                    ru: "Достигните требуемых уровней навыков и уничтожьте цели, чтобы доказать свою ценность Воеводе."
                },
                story: {
                    en: "Voevoda contacted me and filled me in a bit on his squad. If I want to work with them, I've got to show I can handle their tasks.",
                    tr: "Voevoda benimle iletişime geçti ve takımı hakkında bana biraz bilgi verdi. Eğer onlarla çalışmak istiyorsam, görevlerin üstesinden gelebileceğimi kanıtlamalıyım.",
                    ru: "Воевода связался со мной и рассказал немного о своем отряде. Если хочу с ними работать, нужно показать, что я справлюсь с их задачами."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Reach Light Machine Guns skill level 5.",
                            tr: "Hafif Makineli Tüfekler (Light Machine Guns) yeteneğini 5. seviyeye çıkar.",
                            ru: "Достигните 5 уровня навыка «Ручные пулеметы»."
                        }
                    },
                    {
                        text: {
                            en: "Reach Assault Rifles skill level 10.",
                            tr: "Taarruz Tüfekleri (Assault Rifles) yeteneğini 10. seviyeye çıkar.",
                            ru: "Достигните 10 уровня навыка «Штурмовые винтовки»."
                        }
                    },
                    {
                        text: {
                            en: "Reach Stress Resistance skill level 10.",
                            tr: "Stres Direnci (Stress Resistance) yeteneğini 10. seviyeye çıkar.",
                            ru: "Достигните 10 уровня навыка «Стрессоустойчивость»."
                        }
                    },
                    {
                        text: {
                            en: "Reach Strength skill level 15.",
                            tr: "Güç (Strength) yeteneğini 15. seviyeye çıkar.",
                            ru: "Достигните 15 уровня навыка «Сила»."
                        }
                    },
                    {
                        text: {
                            en: "Eliminate any 15 targets without dying.",
                            tr: "Ölmeden herhangi 15 hedefi ortadan kaldır.",
                            ru: "Уничтожьте любые 15 целей, не умирая."
                        }
                    },
                    {
                        text: {
                            en: "Eliminate 4 PMC operatives without dying.",
                            tr: "Ölmeden 4 PMC operatörünü ortadan kaldır.",
                            ru: "Уничтожьте 4 операторов ЧВК, не умирая."
                        }
                    },
                    {
                        text: {
                            en: "After completing all tasks, contact Voevoda again via the Intelligence Center radio with the same frequency and code.",
                            tr: "Tüm görevleri tamamladıktan sonra, aynı frekans ve kodu kullanarak İstihbarat Merkezi radyosu üzerinden Voevoda ile tekrar iletişime geç.",
                            ru: "После выполнения всех задач снова свяжитесь с Воеводой через радио Разведцентра с той же частотой и кодом."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_find_traitors',
            label: {
                en: "Locate the traces of the traitors",
                tr: "Hainlerin izlerini bul",
                ru: "Найти следы предателей"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Find the note mentioning Prapor at the BEAR camp on Lighthouse.",
                    tr: "Deniz Feneri haritasındaki BEAR kampında Prapor'dan bahseden notu bul.",
                    ru: "Найдите записку с упоминанием Прапора в лагере BEAR на Маяке."
                },
                story: {
                    en: "Track down whoever setup the ambush on the Bogatyrs. I'll need to search through the BEAR camps.",
                    tr: "Bogatyr'lara kimin pusu kurduğunu bulmam lazım. Bunun için BEAR kamplarını araştırmam gerekecek.",
                    ru: "Нужно выследить тех, кто устроил засаду на Богатырей. Придется обыскать лагеря BEAR."
                },
                requiredItems: [
                    { en: "Note mentioning Prapor", tr: "Prapor'dan bahseden not", ru: "Записка с упоминанием Прапора" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Lighthouse. Find the BEAR camp on the hill across from Pikes Peak Resort.",
                            tr: "Deniz Feneri haritasına git. Pikes Peak Resort'un tam karşısındaki tepede bulunan BEAR kampını bul.",
                            ru: "Отправляйтесь на Маяк. Найдите лагерь BEAR на холме напротив курорта Пайкс Пик."
                        },
                        images: ['/Story/Batya/Traitors-Map.webp']
                    },
                    {
                        text: {
                            en: "The note is on a metal pole in the camp. Extract after reading it.",
                            tr: "Not, kampın içindeki metal bir direğin üzerinde asılı. Okuduktan sonra baskından çıkış yap.",
                            ru: "Записка находится на металлическом столбе в лагере. Эвакуируйтесь после прочтения."
                        },
                        images: ['/Story/Batya/Traitors-Note.webp']
                    }
                ]
            }
        },
        {
            id: 'step_interrogate_prapor',
            label: {
                en: "Interrogate Prapor",
                tr: "Prapor'u sorgula",
                ru: "Допросить Прапора"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Visit Prapor and confront him about the traitors.",
                    tr: "Prapor'u ziyaret et ve hainler konusunda onunla yüzleş.",
                    ru: "Посетите Прапора и спросите его о предателях."
                },
                story: {
                    en: "Prapor will come clean, but he's just the middle man. There's still more to find.",
                    tr: "Prapor her şeyi itiraf edecek ama o sadece bir aracı. Hala ortaya çıkarılacak çok şey var.",
                    ru: "Прапор во всем признается, но он всего лишь посредник. Предстоит найти еще многое."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open Traders menu. Select Prapor. Complete the interrogation dialogue.",
                            tr: "Satıcılar menüsünü aç. Prapor'u seç. Sorgu diyalogunu tamamla.",
                            ru: "Откройте меню торговцев. Выберите Прапора. Завершите диалог допроса."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_cultists_general',
            label: {
                en: "Find out how the Cultists are connected to the General",
                tr: "Kültistlerin General ile bağlantısını öğren",
                ru: "Узнать связь Сектантов с Генералом"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Shoreline / Woods / Customs", tr: "Kıyı Şeridi / Ormanlık / Gümrük", ru: "Берег / Лес / Таможня" },
                objective: {
                    en: "Investigate the cultist circles and find evidence connecting them to the General.",
                    tr: "Kültist çemberlerini araştır ve onları General'e bağlayan kanıtları bul.",
                    ru: "Исследуйте круги культистов и найдите доказательства их связи с Генералом."
                },
                story: {
                    en: "The Cultists are the next lead. I need to investigate their circles on Shoreline and Woods.",
                    tr: "Kültistler bir sonraki ipucumuz. Kıyı Şeridi ve Ormanlık haritalarındaki çemberlerini araştırmam gerekiyor.",
                    ru: "Культисты — следующая зацепка. Нужно исследовать их круги на Берегу и в Лесу."
                },
                requiredItems: [
                    { en: "Voevoda's photo with a cultist mark", tr: "Voevoda'nın kültist işareti taşıyan fotoğrafı", ru: "Фото Воеводы с меткой культиста" },
                    { en: "Note mentioning General", tr: "General'den bahseden not", ru: "Записка с упоминанием Генерала" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Shoreline: Go to the fishing hut on the small island (Scav Island). Find the photo next to the green crate.",
                            tr: "Kıyı Şeridi: Küçük adadaki (Scav Adası) balıkçı kulübesine git. Yeşil kasanın yanındaki fotoğrafı bul.",
                            ru: "Берег: Отправляйтесь в рыбацкую хижину на маленьком острове (Остров Диких). Найдите фото рядом с зеленым ящиком."
                        },
                        images: ['/Story/Batya/Cultist-ShorelineMap.webp', '/Story/Batya/Cultist-Photo.webp']
                    },
                    {
                        text: {
                            en: "Woods: Go to the marked circle in the woods west of the sawmill near the checkpoint. The note is next to the candles.",
                            tr: "Ormanlık: Testere fabrikasının batısında, kontrol noktası yakınlarındaki ormanın içindeki işaretli çembere git. Not, mumların hemen yanında duruyor.",
                            ru: "Лес: Отправляйтесь в отмеченный круг в лесу к западу от лесопилки у КПП. Записка лежит рядом со свечами."
                        },
                        images: ['/Story/Batya/Cultist-WoodsMap.webp', '/Story/Batya/Cultist-WoodsNote.webp']
                    },
                    {
                        text: {
                            en: "Optional Customs: The note can also be found in the marked room on the third floor of the three-story dorms (Dorm room 314 marked key required).",
                            tr: "İsteğe Bağlı Gümrük: Bu not ayrıca üç katlı yurt binasının üçüncü katındaki işaretli odada da bulunabilir (Yurt odası 314 işaretli anahtarı gerektirir).",
                            ru: "Дополнительно Таможня: Записку также можно найти в отмеченной комнате на третьем этаже трехэтажного общежития (требуется ключ от меченой комнаты 314)."
                        },
                        images: ['/Story/Batya/Cultist-CustomsMap.webp', '/Story/Batya/Cultist-Dorms.webp']
                    }
                ]
            }
        },
        {
            id: 'step_talk_lightkeeper_final',
            label: {
                en: "Talk to Lightkeeper",
                tr: "Işık Muhafızı ile konuş",
                ru: "Поговорить со Смотрителем"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Visit Lightkeeper and learn the truth behind the cultists and the General.",
                    tr: "Işık Muhafızı'nı ziyaret et; kültistler ile General'in arkasındaki gerçeği öğren.",
                    ru: "Посетите Смотрителя и узнайте правду о культистах и Генерале."
                },
                story: {
                    en: "Lightkeeper will tell me the truth behind everything. I need to hear what he knows.",
                    tr: "Işık Muhafızı bana her şeyin arkasındaki gerçeği anlatacak. Onun bildiklerini duymam gerekiyor.",
                    ru: "Смотритель расскажет мне правду обо всем. Мне нужно услышать, что он знает."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Lighthouse. Enter Lightkeeper's area. Complete the dialogue.",
                            tr: "Deniz Feneri haritasına git. Işık Muhafızı'nın alanına gir. Diyalogu tamamla.",
                            ru: "Отправляйтесь на Маяк. Войдите в зону Смотрителя. Завершите диалог."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_collect_documents',
            label: {
                en: "Collect Lightkeeper documents",
                tr: "Işık Muhafızı'nın belgelerini topla",
                ru: "Собрать документы Смотрителя"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Lighthouse", tr: "Deniz feneri", ru: "Маяк" },
                objective: {
                    en: "Collect the Agent network deployment report from Lightkeeper's quarters and wait 12 hours.",
                    tr: "Işık Muhafızı'nın odasından 'Ajan ağı konuşlandırma raporu'nu al ve 12 saat bekle.",
                    ru: "Заберите доклад о развертывании агентурной сети из покоев Смотрителя и подождите 12 часов."
                },
                story: {
                    en: "The documents can be found inside Lightkeeper's Quarters. This will complete the Batya chapter.",
                    tr: "Belgeler Işık Muhafızı'nın Odasında bulunabilir. Bu görev, Batya bölümünü tamamlayacak.",
                    ru: "Документы можно найти в покоях Смотрителя. Это завершит главу «Батя»."
                },
                requiredItems: [
                    { en: "Agent network deployment report", tr: "Ajan ağı konuşlandırma raporu", ru: "Доклад о развертывании агентурной сети" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "In a new raid, return to Lightkeeper's area on Lighthouse. Pick up the report on the red wooden box in the hallway outside his room.",
                            tr: "Yeni bir baskında Deniz Feneri haritasına, Işık Muhafızı'nın bulunduğu alana geri dön. Odasının dışındaki koridorda bulunan kırmızı ahşap kutunun üzerindeki raporu al.",
                            ru: "В новом рейде вернитесь в зону Смотрителя на Маяке. Заберите доклад на красном деревянном ящике в коридоре рядом с его комнатой."
                        },
                        images: ['/Story/Batya/Documents-Report.webp']
                    },
                    {
                        text: {
                            en: "Read the report. The objective completes after 12 hours.",
                            tr: "Raporu oku. Görev hedefi 12 saat sonra tamamlanacaktır.",
                            ru: "Прочитайте доклад. Задача выполнится через 12 часов."
                        }
                    }
                ]
            }
        }
    ]
};